<div class="viewer-panel__viewpoints">
  <div class="viewer-panel__subtitle">Viewpoints</div>
  <div class="viewer-panel__state">Saved: {{ viewer.viewpoints.length }}</div>
  <div class="viewer-panel__state">Viewpoints are stored in the current backend scene.</div>
  <select
    class="viewer-panel__select"
    [value]="viewer.selectedViewpointId ?? ''"
    (change)="viewer.onSelectedViewpointChanged($event)"
  >
    <option value="">Select viewpoint</option>
    <option *ngFor="let viewpoint of viewer.viewpoints" [value]="viewpoint.id">{{ viewpoint.name }}</option>
  </select>
  <label class="viewer-panel__control-label" for="viewpointCreateNameDraft">New viewpoint name</label>
  <input
    id="viewpointCreateNameDraft"
    class="viewer-panel__select"
    type="text"
    [value]="viewer.viewpointCreateNameDraft"
    (input)="viewer.onViewpointCreateNameDraftChanged($event)"
    placeholder="Viewpoint name"
  />
  <div class="viewer-panel__actions">
    <input
      type="button"
      class="demo-button viewer-panel__button"
      value="Save Viewpoint"
      (tap)="viewer.saveCurrentViewpoint()"
    />
    <input
      type="button"
      class="demo-button viewer-panel__button"
      value="Refresh"
      [disabled]="viewer.selectedViewpointId === null"
      (tap)="viewer.refreshSelectedViewpoint()"
    />
    <input
      type="button"
      class="demo-button viewer-panel__button"
      value="Update"
      [disabled]="viewer.selectedViewpointId === null"
      (tap)="viewer.updateSelectedViewpoint()"
    />
    <input
      type="button"
      class="demo-button viewer-panel__button"
      value="Rename"
      [disabled]="viewer.selectedViewpointId === null"
      (tap)="viewer.beginViewpointRename()"
    />
    <input
      type="button"
      class="demo-button viewer-panel__button"
      value="Delete"
      [disabled]="viewer.selectedViewpointId === null"
      (tap)="viewer.deleteSelectedViewpoint()"
    />
    <input
      type="button"
      class="demo-button viewer-panel__button"
      value="Copy Viewpoint URL"
      [disabled]="viewer.selectedViewpointId === null"
      (tap)="viewer.copyViewpointUrlToClipboard()"
    />
  </div>
  <div *ngIf="viewer.viewpointRenameActive" class="viewer-panel__viewpoint-rename">
    <label class="viewer-panel__control-label" for="viewpointNameDraft">Rename viewpoint</label>
    <input
      id="viewpointNameDraft"
      class="viewer-panel__select"
      type="text"
      [value]="viewer.viewpointNameDraft"
      (input)="viewer.onViewpointNameDraftChanged($event)"
      placeholder="Viewpoint name"
    />
    <div class="viewer-panel__actions">
      <input
        type="button"
        class="demo-button viewer-panel__button"
        value="Save Name"
        (tap)="viewer.renameSelectedViewpoint()"
      />
      <input
        type="button"
        class="demo-button viewer-panel__button"
        value="Cancel"
        (tap)="viewer.cancelViewpointRename()"
      />
    </div>
  </div>
</div>
